<template>
  <div id="descriptor-analytics">
    <v-card>
      <div class="pa-5">
        <v-row class="align-sm-center">
          <v-col cols="12">
            <v-card-title class="pa-0">Descriptor Analytics</v-card-title>
          </v-col>
        </v-row>
      </div>

      <v-divider />

      <v-card-text>
        <v-alert v-if="uploadedFileDescriptorError" color="warning" dark>
          {{ uploadedFileDescriptorError }}
        </v-alert>

        <v-row>
          <v-col cols="12" sm="4">
            <v-file-input
              v-model="uploadedFile"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              label="Select a file..."
              :loading="uploadedFileDescriptor"
              :disabled="uploadedFileDescriptor"
              dense
              outlined
            ></v-file-input>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-if="uploadedFileDescriptorResult">
        <v-divider class="my-6" />

        <v-row>
          <v-col cols="12" sm="12" v-if="uploadedFileDescriptorResult.length">
            <v-row>
              <v-col cols="6" sm="6">
                Descriptors missing in Merchanto
              </v-col>
              <v-col cols="12" sm="12">
                <div>
                  <v-data-table :items="uploadedFileDescriptorResult" :headers="headers">
                    <template #[`item.action`]="{ item, index }">
                      <div>
                        <v-btn color="primary" class="me-3 mark-known-button" @click="markKnown(item, index)"> Mark Acknowledge </v-btn>
                      </div>
                    </template>
                    <template #[`item.website`]="{ item }">
                      <div v-if="item.website">{{ item.website.name }}</div>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" v-if="!uploadedFileDescriptorResult.length">
            <v-alert color="success" dark>
              All Descriptors match
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import useDescriptorAnalytics from '@/views/analytics/descriptor-analytics/useDescriptorAnalytics';

export default {
  name: 'DescriptorAnalytics',
  setup() {
    const {
      uploadedFile,
      uploadedFileDescriptor,
      uploadedFileDescriptorResult,
      uploadedFileDescriptorError,
      headers,
      markKnown,
    } = useDescriptorAnalytics();

    return {
      uploadedFile,
      uploadedFileDescriptor,
      uploadedFileDescriptorResult,
      uploadedFileDescriptorError,
      headers,
      markKnown,
    };
  },
};
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.mark-known-button {
  font-size: 10px!important;
  padding: 10px!important;
}
</style>
